import React, { useState } from "react";
import Model from "../Model";
import { SubmitBtn, PreviewBtn } from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import { useTranslation } from "react-i18next";

const CompleteModal = ({
  setPrevieForm,
  setCompleteViewModel,
  setSubmitForm,
  groupId,
  selectedItem,
}) => {
  // const DeleteDevice = () =>
  //   deleteDeviceMutate({ id: selectedItem?.id, groupId });
  const { t, i18n } = useTranslation();
  return (
    <Model width={"w-11/12 max-w-lg"} setOpenModel={setCompleteViewModel}>
      {/* {deleteDeviceLoading && <Loading />} */}
      {/* {!deleteDeviceLoading && ( */}
        <>
          {/* <Title>Are you interested in </Title> */}
          <Title>{t("nextButton")} </Title>

          <div className="w-full flex items-center justify-center space-x-10 mt-8">
            <Preview onClick={() => setPrevieForm()}> {t("PreviewApp")}</Preview>
            <Submit onClick={() => {setSubmitForm(false);
            setCompleteViewModel(false)}}>{t('Proceed')}</Submit>
          </div>
        </>
      {/* )} */}
    </Model>
  );
};

const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Submit = tw.button`px-8 py-3 text-sm bg-green-400 text-white rounded hover:bg-gree-100`;
const Preview = tw.button`px-8 py-3 text-sm bg-gray-100 text-gray-600 rounded hover:bg-gray-200`;

export default CompleteModal;
